import styled from "styled-components";

export const PageLoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
